// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "documentsSection-q2nFJ";
var _5 = "documentsSection__fields-24jwc";
var _6 = "documentsSection__controls-3hiI3";
var _7 = "documentsSection__addFields-3r26B";
var _8 = "buttonAdd-140fR";
var _9 = "documentsSection__emptyWarning-3gAMe";
var _a = "documents__add-19Miq";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "documentsSection", _5 as "documentsSection__fields", _6 as "documentsSection__controls", _7 as "documentsSection__addFields", _8 as "buttonAdd", _9 as "documentsSection__emptyWarning", _a as "documents__add" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "documentsSection": _4, "documentsSection__fields": _5, "documentsSection__controls": _6, "documentsSection__addFields": _7, "buttonAdd": _8, "documentsSection__emptyWarning": _9, "documents__add": _a }
